export default Object.freeze({
  CREAR_EDITAR_SECCION: 1,
  MOSTRAR_OCULTAR_SECCION: 2,
  ELIMINAR_SECCION: 3,
  ORDENAR_SECCION: 4,
  EDITAR_TODAS_SECCIONES: 5,
  AUTORIZAR_RECHAZAR_PUBLICACION_DE_SECCION: 6,
  ELIMINAR_SECCION_AUTORIZADAS: 7,

  AGREGAR_DOCUMENTO: 8,
  EDITAR_DOCUENTO: 9,
  MOSTRAR_OCULTAR_DOCUMENTO: 10,
  ELIMINAR_DOCUMENTO: 11,
  ORDENAR_DOCUMENTO: 12,
  VER_REPORTE_LECTORES: 13,
  AUTORIZAR_PUBLICACION_DE_DOCUMENTOS: 14,
  ELIMINAR_DOCUMENTOS_AUTORIZADOS: 15,

  VER_USUARIOS_INTERNOS: 16,
  SUSPENDER_ACTIVAR_USUARIO_INTERNO: 17,
  CARGA_MASIVA_DE_USUARIOS_INTERNOS: 18,
  
  // VER_USUARIOS_EXTERNOS:19,
  // SUSPENDER_ACTIVAR_USUARIO_EXTERNO: 20,
  // CARGA_MASIVA_USUARIO_EXTERNO: 21,
  // ASIGNACION_SAP_ID: 22,
  // AUTORIZACION_RECHAZO_SOLICITUD_INGRESO_EXTERNOS: 23,

  // CREAR_SITIOS_DE_INTERES: 24,
  // EDITAR_SITIOS_DE_INTERES: 25,
  // MOSTRAR_OCULTAR_SITIOS_DE_INTERES: 26,
  // ELIMINAR_SITIOS_DE_INTERES: 27,
  // ORDENAR_SITIOS_DE_INTERES: 28,
  // AUTORIZAR_PUBLICACION_SITIOS_INTERES: 29,
  // ELIMINAR_SITIOS_INTERES_AUTORIZADOS: 30,

  // CERRAR_SOLICITUDES_PROCESOS: 31,
  // CONFIGURAR_ANEXOS: 32,
  // AUTORIZAR_PUBLICACION_ANEXOS: 33,

  CREAR_ADMINISTRADORES: 34,
  AJUSTAR_INFORMACION_ADMINISTRADORES: 35,
  ELIMINAR_ADMINISTRADORES: 36,

  CREAR_PERFILES: 37,
  AJUSTAR_INFORMACION_PERFILES: 38,
  ELIMINAR_PERFILES: 39,

  CREAR_EMPRESA: 40,
  AJUSTAR_EMPRESA: 41,
  // ELIMINAR_EMPRESA: 42,

  AGREGAR_PAIS: 43,
  EDITAR_PAISES: 44,
  MOSTRAR_OCULTAR_PAISES: 45,
  // ELIMINAR_PAISES: 46,
  // AUTORIZAR_PAISES: 47,

  AGREGAR_IDIOMAS: 48,
  EDITAR_IDIOMAS: 49,
  MOSTRAR_OCULTAR_IDIOMAS: 50,
  ELIMINAR_IDIOMAS: 51,
  // AUTORIZAR_IDIOMAS: 52

  ACCESO_CORREOS: 53,
  ACCESO_REPORTES: 54,
  ACCESO_DETALLE_REPORTES: 55,
  LISTA_NEGRA_DE_DOMINIOS: 56,
  ADMINISTRAR_EVALUADORES: 57,
  ADMINISTRAR_GESTORES: 58,
  ADMINISTRAR_COORDINADORES: 59,
  ADMINISTRAR_ROLES: 60,
  ADMINISTRAR_DICCIONARIO_PROCESOS: 61,
  ADMINISTRAR_ANEXOS_PROCESOS: 62,
  ACCESO_BITACORA: 63,
  VALIDAR_SELLO_DIGITAL: 64,
  ADMINISTRAR_PROVEDOR: 65,
  EDICION_DE_ANEXO_FD: 66,
  TRADUCCION_DE_TEXTOS_FD: 67,
  AUTORIZAR_RECHAZAR_FD: 68,
  TRADUCCION_INACTIVOS_FD: 69,


  ADMINISTRAR_TIPO_USUARIOS: 10000,
})